import styled from 'styled-components';

const EditorStyle = styled.div`
   --tableBorderColor: var(--lightGreen);

	* {
		font-family: var(--futura);
		line-height: var(--lineHeight);
		color: var(--black);
	}

	h5 {
		font-weight: 500;
		font-size: var(--h2L);
	}

	h6 {
		font-size: var(--h2);
		font-weight: 500;
	}

	p {
		font-weight: 400;
        font-size: var(--h4);
	}

	a {
		font-weight: 400;
		text-decoration: underline;
		transition: all var(--trTime) ease-out;

		@media (hover: hover) {
			&:hover {
				text-decoration: none;
			}
		}
	}

	strong {
		font-weight: 600;
	}

	ol {
		list-style-position: inside;

		li {
			font-weight: 400;
            font-size: var(--h4);
		}
	}

	ul {
		list-style: disc;
		list-style-position: inside;

		li {
			font-weight: 400;
            font-size: var(--h4);
		}
	}

	blockquote {
		border-left: 3px solid var(--black);
		padding-left: 2vw;
		font-weight: 400;
	}

	figure.image {
		margin: 16px 0;
		display: block;
		max-width: 100%;
		width: 100%;
		position: relative;
		overflow: hidden;
		--proportion: 51.7%;
	}

	figure.image::before {
		content: '';
		display: block;
		padding-top: var(--proportion);
	}

	figure.image img {
		display: block;
		position: absolute;
		inset: 0;
		width: 100%;
		max-width: 100%;
		height: 100%;
		object-fit: contain;
	}

	figure.image figcaption {
		display: table-caption;
		caption-side: bottom;
		font-size: var(--h5);
		color: var(--gray2);
		padding-top: 8px;
	}

	figure.image.image-style-block {
		margin-left: auto;
		margin-right: auto;
	}

	figure.image.image-style-align-left,
	figure.image.image-style-side {
		float: left;
		margin-right: 16px;
		max-width: 50%;
	}

	figure.image.image-style-align-right {
		float: right;
		margin-left: 16px;
		max-width: 50%;
	}

	figure.image.image_resized {
		display: block;
		position: static;
		overflow: visible;
	}

	figure.image.image_resized::before {
		display: none;
	}

	figure.image.image_resized img {
		width: 100%;
		position: static;
		height: auto;
		object-fit: contain;
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		figure.image.image-style-align-left,
		figure.image.image-style-align-right,
		figure.image.image-style-side {
			float: none;
			margin-left: 0;
			margin-right: 0;
			max-width: 100%;
		}
	}

	figure.table {
		overflow-x: auto;

		table {
			width: 100%;
			border-collapse: collapse;
		}

		th,
		td {
			border: 1px solid var(--tableBorderColor);
			padding: 12px;
			text-align: left;
			font-weight: 400;
			font-size: var(--h4);
		}
	}

	table {
		width: 100%;
		border-collapse: collapse;

		th,
		td {
			border: 1px solid var(--tableBorderColor);
			padding: 12px;
			text-align: left;
			font-weight: 400;
			font-size: var(--h4);
		}
	}
`;

export default EditorStyle;
